export default {
  sets: [],
  tags: [],
  compress: true,
};
